export default __webpack_public_path__ + "static/media/mock_up_sticker_01.df342fd7.mp4";